module.exports = __webpack_public_path__ + "img/sbzc_10.bdfa5f40.jpg";